import { createFileRoute } from '@tanstack/react-router';
import {
  cachedApprovedOrganization,
  interestedRunnersQuery,
  organizationEventQuery,
} from '@/features/organizer/api';
import { RunnersPage } from '@/features/organizer/pages/RunnersPage';
import { runnersSearchSchema } from '@/features/organizer/search';

export const Route = createFileRoute('/_authed/org/$organizationId/events/$eventId/runners')({
  staticData: { help: 'interested-runners' },
  validateSearch: runnersSearchSchema,
  loader: ({ context: { queryClient }, params }) => {
    const organization = cachedApprovedOrganization(queryClient, params.organizationId);
    if (!organization) return;
    void queryClient.prefetchQuery(organizationEventQuery(organization, params.eventId));
    void queryClient.prefetchQuery(interestedRunnersQuery(organization, params.eventId));
  },
  component: RunnersRoute,
});

function RunnersRoute() {
  const { eventId } = Route.useParams();
  return <RunnersPage eventId={eventId} />;
}
